import { render, staticRenderFns } from "./General.vue?vue&type=template&id=84d57fa2&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.vue?vue&type=style&index=0&id=84d57fa2&lang=scss&scoped=true&"
import style1 from "./General.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d57fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d57fa2')) {
      api.createRecord('84d57fa2', component.options)
    } else {
      api.reload('84d57fa2', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=84d57fa2&scoped=true&", function () {
      api.rerender('84d57fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/General.vue"
export default component.exports